import { getConversationHydrationCoordinator } from './conversationHydrationCoordinator';
import type { ChatStoreAction } from './types';

export type RemoveConversationFromStoreArgs = {
	conversationId: string;
	/** Capture before awaiting deletion; omitted by unrelated metadata-cleanup callers. */
	promptHistoryContext?: { requestToken: object; sessionId: string };
};

/** Removes conversation metadata and, for a confirmed local deletion, its cached prompts. */
export const removeConversationFromStore =
	({ conversationId, promptHistoryContext }: RemoveConversationFromStoreArgs): ChatStoreAction =>
	({ getState, setState }, { assistanceService, getConversationHydrationScopeKey }) => {
		const scopeKey = getConversationHydrationScopeKey?.();
		if (scopeKey != null) {
			getConversationHydrationCoordinator(assistanceService, scopeKey).markRemoved(conversationId);
		}
		const { conversations, promptHistory } = getState();
		const { [conversationId]: _, ...otherConversations } = conversations;
		let updatedHistory: typeof promptHistory;
		if (promptHistoryContext && promptHistory?.requestToken === promptHistoryContext.requestToken) {
			const removedSessionIds = new Set([
				...(promptHistory.removedSessionIds ?? []),
				conversationId,
				promptHistoryContext.sessionId,
			]);
			updatedHistory = {
				...promptHistory,
				removedSessionIds: [...removedSessionIds],
				items: promptHistory.items.filter(({ sessionId }) => !removedSessionIds.has(sessionId)),
			};
		}
		setState({
			conversations: otherConversations,
			...(updatedHistory ? { promptHistory: updatedHistory } : {}),
		});
	};
